module.exports = __webpack_public_path__ + "static/media/commute-img-004.6535fab5.jpg";